<app-si-dialog [isLoading]="isLoading$ | async" header="Clear Search Criteria" modalFooterClasses="si-dialog__footer--centered" (close)="onClose()">
	<ng-template appDialogBody>
		<div class="px-16 py-6">
			<div class="flex items-start gap-5">
				<fa-icon class="text-danger shrink-0 mt-0.5" [icon]="['fal', 'circle-exclamation']" size="2x"></fa-icon>
				<div>
					@if (activeSearch) {
						<p class="m-0">Do you want to save <strong class="font-700 break-words">{{ activeSearch.searchName }}</strong> before clearing? You can:</p>
						<ul class="mt-2 mb-0">
							@if (canUpdateSearch) {
								<li>Update <strong class="font-700 break-words">{{ activeSearch.searchName }}</strong></li>
							}
							<li>Save as a new search</li>
							<li>Discard your changes and clear the search</li>
						</ul>
					} @else {
						<p class="m-0">Do you want to save this search before clearing?</p>
					}
				</div>
			</div>
		</div>
	</ng-template>
	<ng-template appDialogFooter>
		<button matButton="outlined" type="button" (click)="onClose()">Cancel</button>
		<button matButton="filled" type="button" class="mat-error" (click)="onDoNotSave()">Do Not Save</button>
		@if (hasExistingSavedSearch) {
			@if (canUpdateSearch) {
				<button
					matButton="filled"
					type="button"
					class="si-menu-trigger"
					[matMenuTriggerFor]="saveActionsMenu"
					[disabled]="isLoading$ | async"
				>
					<span>Save</span>
					<span class="si-menu-trigger-icon" aria-hidden="true"></span>
				</button>
			} @else {
				<button matButton="filled" type="button" [disabled]="isLoading$ | async" (click)="onOpenSaveDialog()">Save New</button>
			}
		} @else {
			<button matButton="filled" type="button" [disabled]="isLoading$ | async" (click)="onOpenSaveDialog()">Save</button>
		}
	</ng-template>
</app-si-dialog>

<mat-menu #saveActionsMenu="matMenu" xPosition="before">
	<button mat-menu-item type="button" (click)="onUpdateSearch()" [disabled]="isLoading$ | async">
		Update
	</button>
	<button mat-menu-item type="button" (click)="onOpenSaveDialog()" [disabled]="isLoading$ | async">
		Save New
	</button>
</mat-menu>
